var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var EMPTY_SELECTION = {
    mode: "none",
    includeIds: new Set(),
    excludeIds: new Set(),
};
var withIds = function (set, ids) {
    var next = new Set(set);
    ids.forEach(function (id) { return next.add(id); });
    return next;
};
var withoutIds = function (set, ids) {
    var next = new Set(set);
    ids.forEach(function (id) { return next.delete(id); });
    return next;
};
var pickedRows = function (includeIds) {
    return includeIds.size === 0
        ? EMPTY_SELECTION
        : { mode: "page", includeIds: includeIds, excludeIds: new Set() };
};
export var selectPage = function (state, pageIds) {
    if (pageIds.length === 0)
        return state;
    if (state.mode === "all") {
        return __assign(__assign({}, state), { excludeIds: withoutIds(state.excludeIds, pageIds) });
    }
    return pickedRows(withIds(state.includeIds, pageIds));
};
export var deselectPage = function (state, pageIds) {
    if (pageIds.length === 0 || state.mode === "none")
        return state;
    if (state.mode === "all") {
        return __assign(__assign({}, state), { excludeIds: withIds(state.excludeIds, pageIds) });
    }
    return pickedRows(withoutIds(state.includeIds, pageIds));
};
export var toggleRow = function (state, id) {
    if (state.mode === "all") {
        return state.excludeIds.has(id)
            ? __assign(__assign({}, state), { excludeIds: withoutIds(state.excludeIds, [id]) }) : __assign(__assign({}, state), { excludeIds: withIds(state.excludeIds, [id]) });
    }
    return pickedRows(state.includeIds.has(id)
        ? withoutIds(state.includeIds, [id])
        : withIds(state.includeIds, [id]));
};
export var selectAcrossFilter = function () { return ({
    mode: "all",
    includeIds: new Set(),
    excludeIds: new Set(),
}); };
export var isRowSelected = function (state, id) {
    return state.mode === "all" ? !state.excludeIds.has(id) : state.includeIds.has(id);
};
export var isPageSelected = function (state, pageIds) {
    return state.mode !== "none" &&
        pageIds.length > 0 &&
        pageIds.every(function (id) { return isRowSelected(state, id); });
};
export var countSelected = function (state, filterTotal) {
    if (state.mode === "none")
        return 0;
    if (state.mode === "page")
        return state.includeIds.size;
    return Math.max(0, (filterTotal !== null && filterTotal !== void 0 ? filterTotal : 0) - state.excludeIds.size);
};
